import { afterEveryRender, Directive, ElementRef, inject, signal } from '@angular/core';

@Directive({
  selector: '[libOverflow]',
  exportAs: 'libOverflow',
  standalone: true,
})
export class OverflowDirective {
  private readonly elementRef = inject(ElementRef);

  readonly isTruncated = signal(false);

  constructor() {
    afterEveryRender(() => {
      const element = this.elementRef.nativeElement;
      this.isTruncated.set(element.scrollWidth > element.clientWidth);
    });
  }
}
